export default "__VITE_PUBLIC_ASSET__193bb68b__"